import { Box, SvgIcon } from '@mui/material';

import { neutrals } from '@toolbox/style/theme/common/ThemeProvider/colors';

import type React from 'react';
import type { BaseIconProps } from '../types';

export const CheckBoxCheckedIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
      <Box
        component="rect"
        sx={({ palette }) => ({
          fill: palette.success.light,
          stroke: neutrals.dark,
        })}
        x="4"
        y="4"
        width={16}
        height={16}
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <Box
        component="path"
        sx={({ palette }) => ({ fill: palette.success.main })}
        d="M8.20711 12.2929C7.81658 11.9024 7.18342 11.9024 6.79289 12.2929C6.40237 12.6834 6.40237 13.3166 6.79289 13.7071L8.20711 12.2929ZM10 15.5L9.29289 16.2071C9.68342 16.5976 10.3166 16.5976 10.7071 16.2071L10 15.5ZM17.2071 9.70711C17.5976 9.31658 17.5976 8.68342 17.2071 8.29289C16.8166 7.90237 16.1834 7.90237 15.7929 8.29289L17.2071 9.70711ZM6.79289 13.7071L9.29289 16.2071L10.7071 14.7929L8.20711 12.2929L6.79289 13.7071ZM10.7071 16.2071L17.2071 9.70711L15.7929 8.29289L9.29289 14.7929L10.7071 16.2071Z"
      />
    </SvgIcon>
  );
};
